/* eslint max-lines: ["error", {"max": 2000, "skipComments": true, "skipBlankLines": true }] */
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { getPartners } from 'store/thunks/partnerThunks';

import CreateOrderForm, { steps } from './components/CreateOrderForm';
import { NewOrderFormProvider } from './hooks/useNewOrderForm';

const CreateOrder = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPartners());
  }, [dispatch]);

  return (
    <NewOrderFormProvider stepsLength={steps.length}>
      <CreateOrderForm />
    </NewOrderFormProvider>
  );
};

export default CreateOrder;
